const initialState = () => {
  const data_user = null;
  const stateUser = 6;
  const minutes_expire = 0;
  const dataUserState = 1;
  const messagingSearchRange = null;
  return { data_user, stateUser, minutes_expire, dataUserState, messagingSearchRange };
};

const state = initialState();

export default state;
